import { TaskCreateDto } from '@maia/shared';
import { service } from '@maia/task';
import { ClaimCard, PageHeader } from '@maia/ui';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import * as v from 'valibot';
import { getClaimOptions } from '../../../../features/claim/claim/queryOptions';
import { CreateTaskForm } from '../../../../features/task/new/form';

export const Route = createFileRoute('/_authenticated/tasks/new/claim')({
  component: Page,
  loaderDeps: ({ search: { guid } }) => ({ guid }),
  loader: ({ context: { queryClient }, deps: { guid } }) =>
    queryClient.ensureQueryData(getClaimOptions(guid)),
  validateSearch: v.object({
    guid: v.string(),
  }),
});

function Page() {
  const data = Route.useLoaderData();
  const navigate = useNavigate();

  const { mutate } = useMutation({
    mutationFn: (task: Omit<TaskCreateDto, 'linked_item'>) =>
      service.create({
        customerGuid: data.customer.guid,
        ...task,
        linked_item: { guid: data.guid, type: 'claim' },
      }),
    onSuccess: ({ task_guid }) => navigate({ to: `/tasks/${task_guid}` }),
  });

  return (
    <div className="layout-sidebar">
      <PageHeader className="area-page-header" title="Taak details invullen" />
      <div className="bg-primary50 p-32">
        <ClaimCard claim={data} />
      </div>
      <CreateTaskForm
        linkedItem={{
          guid: data.guid,
          type: 'claim',
        }}
        onSubmit={async (value) => mutate(value)}
      />
    </div>
  );
}
